import {useEffect, useState} from "react";

type CssVariable = {
    PrimaryColor: Color,
    PrimaryGreyColor1: Color,
    PprimaryGreyColor2: Color,

    ContraryColor: Color,

    LightColor: Color,
    DarkColor: Color,

    PositiveColor: Color,
    NegativeColor: Color,
}

const defaults = {
    PrimaryColor: '#ffd0e8',
    PrimaryGreyColor1: '#54424b',
    PprimaryGreyColor2: "#bba5b0",

    ContraryColor: "#D0FFE7",

    LightColor: "#ffffff",
    DarkColor: "#000000",

    PositiveColor: "#43B05C",
    NegativeColor: "#ED8A19",
} as const

export const  useCSSVariables = () => {
    const [cssVariables, setCssVariables] = useState<CssVariable>(defaults)
    useEffect(() => {
        setCssVariables({
            PrimaryColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-color') as Color,
            PrimaryGreyColor1: getComputedStyle(document.documentElement).getPropertyValue('--primary-grey-color1') as Color,
            PprimaryGreyColor2: getComputedStyle(document.documentElement).getPropertyValue('--primary-grey-color2') as Color,

            ContraryColor: getComputedStyle(document.documentElement).getPropertyValue('--contrary-color') as Color,

            LightColor: getComputedStyle(document.documentElement).getPropertyValue('--light-color') as Color,
            DarkColor: getComputedStyle(document.documentElement).getPropertyValue('--dark-color') as Color,

            PositiveColor: getComputedStyle(document.documentElement).getPropertyValue('--positive-color') as Color,
            NegativeColor: getComputedStyle(document.documentElement).getPropertyValue('--negative-color') as Color,
        })
    }, [setCssVariables])

    return cssVariables
}
